module.exports = "uniform sampler2D u_WaterInfoTexture;\r\nvarying vec3 v_WorldPos;\r\nvarying vec2 v_Uv;\r\nvoid main() {\r\n    vec4 info = texture2D(u_WaterInfoTexture, uv);\r\n    /* switch to xz plane */\r\n\tvec4 worldPos = modelMatrix * vec4(position + vec3(0.0, 0.0, info.r), 1.0);\r\n\tgl_Position = projectionMatrix * viewMatrix * worldPos;\r\n\tv_WorldPos = worldPos.xyz;\r\n\tv_Uv = uv;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/water/vertex.glsl
// module id = 5
// module chunks = 0